var els = $('.selectize-tags');
if (els.length > 0) {
  require.ensure('../modules/tags', function(require) {
    var Tags = require('../modules/tags');
    els.each(function() {
      return new Tags(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/tags.initializer.js